import React from 'react';

import {
  Globe,
  BookOpen
} from 'lucide-react';

import { User } from 'firebase/auth';

interface MobileBottomNavProps {

  mode: 'global' | 'personal';

  onModeChange: (
    mode: 'global' | 'personal'
  ) => void;

  user?: User;

  onProfileClick?: () => void;
}

const MobileBottomNav: React.FC<
  MobileBottomNavProps
> = ({

  mode,
  onModeChange,
  user,
  onProfileClick,

}) => {

  return (

    <div
      className="
        fixed
        bottom-0
        left-0
        right-0
        z-50

        h-20

        bg-dark-900/40
        backdrop-blur-lg

        border-t border-white/10

        backdrop-blur-xl

        flex
        items-center
        justify-around

        px-6
      "
    >

      <button
        onClick={() =>
          onModeChange('global')
        }
        className={`
          flex
          flex-col
          items-center
          justify-center
          gap-1
          transition-all

          ${
            mode === 'global'
              ? 'text-purple-400'
              : 'text-dark-300'
          }
        `}
      >

        <Globe size={24} />

      </button>

      <button
        onClick={() =>
          onModeChange('personal')
        }
        className={`
          flex
          flex-col
          items-center
          justify-center
          gap-1
          transition-all

          ${
            mode === 'personal'
              ? 'text-purple-400'
              : 'text-dark-300'
          }
        `}
      >

        <BookOpen size={24} />

      </button>

      <button
        onClick={onProfileClick}
        className="
          flex
          items-center
          justify-center
        "
      >

        <img
          src={
            user?.photoURL ||
            'https://ui-avatars.com/api/?name=User&background=7C3AED&color=fff'
          }

          alt="User"

          className="
            w-10
            h-10
            rounded-full
            object-cover
            border-2
            border-purple-500
          "
        />

      </button>

    </div>
  );
};

export default MobileBottomNav;